import { render, staticRenderFns } from "./dialogEditAdmin.vue?vue&type=template&id=1a9332d8&scoped=true"
import script from "./dialogEditAdmin.vue?vue&type=script&lang=js"
export * from "./dialogEditAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9332d8",
  null
  
)

export default component.exports